import React, { useState } from 'react'
import logo from "../../assets/images/logo-locwire.svg";
import { Form, InputGroup } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faEye, faEyeSlash } from '@fortawesome/free-regular-svg-icons';
import { faLock } from '@fortawesome/free-solid-svg-icons';
import "./Auth.css";
import * as Api from "../../config/Apis"
import endPoints from "../../config/endpoints";
import { useNavigate } from 'react-router-dom';

export default function Login() {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);

  const [btnLoading, setBtnLoading] = useState(false)
  const [error, setError] = useState(false)
  const [value, setValue] = useState({
    email: "",
    password: ""
  })
  const handleChange = (e) => {
    setValue({ ...value, [e.target.name]: e.target.value })
  }

  const submit = (e) => {
    e.preventDefault();
    const hasError =
      !value.email ||
      !value.password;
    setError(hasError);
    if (!hasError) {
      setBtnLoading(true)
      let body = {
        ...value
      }
      Api.PostApi(endPoints.LOGIN, body).then(res => {
        console.log(res)
        setBtnLoading(false)
        if (res.error === true) {
          Api.Alert(res.response.data.error, "error")
        } else {
          if (res.data.data && res.data.data?.token) {
            localStorage.setItem("LW_TOKEN", res.data.data?.token);
            navigate("/")
          }
        }
      })
    }
  }
  return (
    <div className='login_outer'>
      <div className='login_inner'>
        <div className='login_logo'>
          <img src={logo} alt='Locwire' width={150} />
        </div>
        <h1>Login</h1>
        <div className='login_form'>
          <Form>
            <div className="mb-3">
              <Form.Label htmlFor="email">Email</Form.Label>
              <InputGroup className="mb-1">
                <InputGroup.Text id="email">
                  <FontAwesomeIcon icon={faEnvelope} />
                </InputGroup.Text>
                <Form.Control
                  placeholder=""
                  type='email'
                  aria-label="Email"
                  aria-describedby="email"
                  autoComplete="new-password"
                  value={value.email}
                  name={"email"}
                  onChange={handleChange}
                />
              </InputGroup>
              {error && !value.email && <p className="error m-0 text-start"><small>This field is required.</small></p>}
            </div>
            <div className="mb-3">
              <Form.Label htmlFor="password">Password</Form.Label>
              <InputGroup className="mb-1">
                <InputGroup.Text id="password">
                  <FontAwesomeIcon icon={faLock} />
                </InputGroup.Text>
                <Form.Control
                  placeholder=""
                  type={showPassword ? 'text' : 'password'}
                  aria-label="Password"
                  aria-describedby="password"
                  autoComplete="new-password"
                  value={value.password}
                  name={"password"}
                  onChange={handleChange}
                />
                <InputGroup.Text onClick={() => setShowPassword(!showPassword)} style={{ cursor: "pointer" }}>
                  <FontAwesomeIcon icon={!showPassword ? faEyeSlash : faEye} />
                </InputGroup.Text>
              </InputGroup>
              {error && !value.password && <p className="error m-0 text-start"><small>This field is required.</small></p>}
            </div>
            <button className='btn btn-primary w-100' onClick={submit} disabled={btnLoading}>
              {btnLoading ? "Please wait..." : "Login"}
            </button>
          </Form>
        </div>
      </div>
    </div>
  )
}
